import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { ZonesSubscriptionsEffects } from './effects/zones-subscriptions.effects';
import { ZoneGroupsEffects } from './effects/zone-subscription-groups.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('zones', reducers),
    EffectsModule.forFeature([ZonesSubscriptionsEffects]),
    EffectsModule.forFeature([ZoneGroupsEffects])
  ]
})
export class ZonesStoreModule {}
